// Shared ignore conventions for the live watcher.
// Both chokidar ignored option and the polling fallback directory walker
// must filter the same set of paths. Drift on scaffold output (.cai/) and
// build artifacts (.next, dist, etc.) is noise - not user-authored code.
// Keep this list in sync with .cai/context/conventions.md.

const IGNORE_DIR_NAMES: readonly string[] = [
  "node_modules",
  ".git",
  "dist",
  "build",
  ".next",
  ".turbo",
  ".cache",
  ".parcel-cache",
  "coverage",
  ".svelte-kit",
  ".nuxt",
  ".output",
  ".vercel",
  "target",
  "out",
  "__snapshots__",
  ".nyc_output",
  "junit",
  ".cai",
];

export const WATCH_IGNORE_DIRS: ReadonlySet<string> = new Set(IGNORE_DIR_NAMES);

function buildIgnoreGlobs(): string[] {
  const out: string[] = [];
  for (let i = 0; i < IGNORE_DIR_NAMES.length; i++) {
    const name = IGNORE_DIR_NAMES[i];
    out.push("**/" + name + "/**");
  }
  return out;
}

export const WATCH_IGNORE_GLOBS: readonly string[] = buildIgnoreGlobs();

export const WATCH_IGNORE_EXTENSIONS: ReadonlySet<string> = new Set([
  ".log",
  ".tmp",
  ".swp",
  ".swo",
  ".DS_Store",
  ".pid",
  ".lock",
]);